import Typography from '../../Typography';
import CircularProgress from '../../CircularProgress';
import { InputBase } from '../InputBase';

export function CampoInputBase({
  textarea = false,
  alerta,
  mensagem,
  valor,
  setValor,
  label,
  placeholder = '',
  eventoClique,
  carregando,
  desabilidato = false,
  nota,
  multilinhas = false,
  textoAuxiliar,
  className,
  componentInterno,
  rows,
  onMouseLeave
}) {
  //TODO: mudar component input
  return (
    <div
      className={`w-full grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex ${className}`}
    >
      <Typography component="body1-semibold">{label}</Typography>
      <InputBase
        rows={rows}
        textarea={textarea}
        componentInterno={componentInterno}
        placeholder={placeholder}
        component="active"
        disabled={desabilidato}
        value={valor == 'no_value' ? '' : valor}
        onChange={e => setValor(e.target.value)}
        onMouseLeave={onMouseLeave}
        icon={
          carregando && (
            <div className="absolute top-2/4 right-3 grid h-5 w-5 -translate-y-2/4 place-items-center text-blue-gray-500">
              <CircularProgress />
            </div>
          )
        }
      />
    </div>
  );
}
